import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { colorsModeUI } from '../modeUI';
import UiHeader from '../uiHeader';
import UiButton from '../uiButton';
import './index.css';

/**
 * Panel secondary
 * This component shows a basic container with a content and title.
 * parameters (props)
 * @param object content: required
 * @param string title:required
 * @param object iconTitle
 * @param function close
 * @param bool showTitle
 * @param string mode
 */
export default class PanelSecondary extends Component {
  constructor(props) {
    super(props);
    this.showTitle = this.showTitle.bind(this);
  }

  /**
   * Show title
   * this function shows the title and the button close
   */
  showTitle() {
    const { title, iconTitle, close, mode } = this.props;
    return (
      <div className="title-panel-secondary">
        <div>
          <UiHeader header="h3" content={title} icon={iconTitle} mode={mode} />
        </div>
        <div>
          <UiButton
            showLabels={false}
            sizeButton="mini"
            iconName="close"
            onClick={close}
            id="close"
            mode={mode}
            primary
          />
        </div>
      </div>
    );
  }

  render() {
    const { content, showTitle } = this.props;
    const style = {};

    return (
      <div className="panel-secondary" style={style}>
        {showTitle && this.showTitle()}
        {content}
      </div>
    );
  }
}

PanelSecondary.propTypes = {
  content: PropTypes.node.isRequired,
  title: PropTypes.string,
  iconTitle: PropTypes.objectOf(Object),
  close: PropTypes.func,
  showTitle: PropTypes.bool,
  mode: PropTypes.string,
};

PanelSecondary.defaultProps = {
  title: '',
  iconTitle: null,
  close: () => {},
  showTitle: true,
  mode: null,
};
